// import React from 'react'
import { useState } from "react"
import "./Search.css" // You can define your own CSS styles

const Search = props => {
  const [searchText, setSearchText] = useState("");

  const onSearchChange = event => {
    setSearchText(event.target.value)
    props.onSearch(event.target.value);

  }

  const onSearch = event => {
    props.onSearch(searchText);
  }

  return (
    <div>
      <div className="search-container">
        <input
          type="search"
          name=""
          value={searchText}
          onChange={onSearchChange}
          className="search-input-box"
          id=""
          placeholder="Type to filter"
        />
        <span className="p-1x v-align-center cursor-pointer" onClick={onSearch}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="25"
            fill="currentColor"
            className="bi bi-search"
            viewBox="0 0 25 25"
          >
            <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
          </svg>
          <span className="text-white">Search</span>
          {/* <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="25"
            fill="currentColor"
            className="bi bi-search-heart"
            viewBox="0 0 25 25"
          >
            <path d="M6.5 4.482c1.664-1.673 5.825 1.254 0 5.018-5.825-3.764-1.664-6.69 0-5.018" />
            <path d="M13 6.5a6.47 6.47 0 0 1-1.258 3.844q.06.044.115.098l3.85 3.85a1 1 0 0 1-1.414 1.415l-3.85-3.85a1 1 0 0 1-.1-.115h.002A6.5 6.5 0 1 1 13 6.5M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11" />
          </svg> */}
        </span>
      </div>
      <hr />
    </div>
  )
}

export default Search
